// 获取当前时间格式：年月日时分秒
export const getTime = () => {
  const now = new Date();
  const formattedTime = now.getFullYear().toString() +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    now.getDate().toString().padStart(2, '0') +
    now.getHours().toString().padStart(2, '0') +
    now.getMinutes().toString().padStart(2, '0') +
    now.getSeconds().toString().padStart(2, '0');
  console.log(formattedTime);
  return formattedTime;
}